import axios from "axios";
import { toast } from "react-toastify";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  PARKING_LOADING,
  PARKING_ERROR,
  PARKING_LIST
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/parking";

export const setLoading = (status) => ({
  type: PARKING_LOADING,
  payload: status
});

export const getList = (criteria = []) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}${ENDPOINT}/list`, {
    criteria
  })
    .then(response => {
      dispatch({
        type: PARKING_LIST,
        payload: {
          content: response.data.content
        }
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PARKING_ERROR));
    });
};

export const add = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${scooterUrl}${ENDPOINT}`, data)
    .then(() => {
      toast("New parking successfully added", {
        type: toast.TYPE.SUCCESS,
      });
      callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PARKING_ERROR));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const remove = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  axios.delete(`${scooterUrl}${ENDPOINT}/${id}`)
    .then(() => {
      toast(`Parking ${id} successfully removed`, {
        type: toast.TYPE.SUCCESS,
      });
      callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, PARKING_ERROR));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/parking/actions.js